var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "auth-saas auth-saas--pro", attrs: { id: "wrapper" } },
    [
      _c("div", { staticClass: "auth-saas__layout auth-saas__layout--split" }, [
        _c(
          "aside",
          {
            staticClass:
              "auth-saas__brand-panel nk-split-stretch toggle-break-lg toggle-slide toggle-slide-right d-none d-lg-flex",
            attrs: {
              "data-toggle-body": "true",
              "data-content": "athPromo",
              "data-toggle-screen": "lg",
              "data-toggle-overlay": "true",
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "auth-saas__brand-content" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("h2", { staticClass: "auth-saas__brand-headline" }, [
                _vm._v("Operate your education platform with precision."),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "auth-saas__brand-copy" }, [
                _vm._v(
                  "\n                    Sign in to manage subscriptions, tenant instances, and administrative controls from a single secure workspace.\n                "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "auth-saas__capability-list" }, [
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "auth-saas__capability-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "school" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(2),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "auth-saas__capability-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "shield" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(3),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "auth-saas__capability-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "chart" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(4),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "auth-saas__brand-meta" }, [
                _vm._v("Encrypted sessions · Optional two-factor verification"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "auth-saas__form-column auth-saas__form-column--split",
          },
          [
            _c("div", { staticClass: "absolute-top-right d-lg-none p-3" }, [
              _c(
                "a",
                {
                  staticClass: "auth-saas__icon-btn toggle",
                  attrs: {
                    href: "#",
                    "data-target": "athPromo",
                    "aria-label": "About Sipinor Admin",
                  },
                },
                [_c("admin-icon", { attrs: { name: "info" } })],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "auth-saas__form-main" }, [
              _c(
                "div",
                {
                  staticClass:
                    "auth-saas__form-inner auth-saas__form-inner--enter",
                },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "auth-saas__card auth-saas__card--login" },
                    [
                      _c("h1", { staticClass: "auth-saas__title" }, [
                        _vm._v(_vm._s(_vm.trans("auth.login"))),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "auth-saas__subtitle" }, [
                        _vm._v(
                          "Enter your credentials to continue to the admin console."
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          staticClass: "form-validate is-alter",
                          attrs: { id: "loginform" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.submit.apply(null, arguments)
                            },
                            keydown: function ($event) {
                              return _vm.loginForm.errors.clear(
                                $event.target.name
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "auth-saas__label",
                                  attrs: { for: "email-address" },
                                },
                                [_vm._v("Email")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "auth-saas__input-wrap" },
                                [
                                  _c("admin-icon", {
                                    attrs: {
                                      name: "mail",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.loginForm.email,
                                        expression: "loginForm.email",
                                      },
                                    ],
                                    staticClass: "auth-saas__input",
                                    attrs: {
                                      id: "email-address",
                                      type: "text",
                                      name: "email",
                                      autocomplete: "username",
                                      placeholder: _vm.trans("auth.email"),
                                    },
                                    domProps: { value: _vm.loginForm.email },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.loginForm,
                                          "email",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("show-error", {
                                staticClass: "text-danger",
                                attrs: {
                                  "form-name": _vm.loginForm,
                                  "prop-name": "email",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "div",
                                { staticClass: "auth-saas__row" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "auth-saas__label mb-0",
                                      attrs: { for: "login-password" },
                                    },
                                    [_vm._v("Password")]
                                  ),
                                  _vm._v(" "),
                                  _vm.getConfig("reset_password")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "auth-saas__link",
                                          attrs: { to: "/password" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.trans("auth.reset_here!")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "auth-saas__input-wrap" },
                                [
                                  _c("admin-icon", {
                                    attrs: {
                                      name: "lock",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.loginForm.password,
                                        expression: "loginForm.password",
                                      },
                                    ],
                                    staticClass: "auth-saas__input",
                                    attrs: {
                                      id: "login-password",
                                      type: "password",
                                      name: "password",
                                      autocomplete: "current-password",
                                      placeholder: _vm.trans("auth.password"),
                                    },
                                    domProps: { value: _vm.loginForm.password },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.loginForm,
                                          "password",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("show-error", {
                                staticClass: "text-danger",
                                attrs: {
                                  "form-name": _vm.loginForm,
                                  "prop-name": "password",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group mb-0" }, [
                            _c(
                              "button",
                              {
                                staticClass: "auth-saas__btn",
                                attrs: {
                                  type: "submit",
                                  disabled: _vm.loginForm.busy,
                                },
                              },
                              [
                                _vm.loginForm.busy
                                  ? _c("span", {
                                      staticClass: "auth-saas__btn-spinner",
                                      attrs: { "aria-hidden": "true" },
                                    })
                                  : _c("admin-icon", {
                                      attrs: {
                                        name: "arrow-right",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.trans("auth.login"))),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(6),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "auth-saas__brand-atmosphere",
        attrs: { "aria-hidden": "true" },
      },
      [
        _c("span", { staticClass: "auth-saas__brand-grid" }),
        _vm._v(" "),
        _c("span", {
          staticClass: "auth-saas__brand-glow auth-saas__brand-glow--a",
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "auth-saas__brand-glow auth-saas__brand-glow--b",
        }),
        _vm._v(" "),
        _c("span", { staticClass: "auth-saas__brand-beam" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__brand-lockup" }, [
      _c(
        "span",
        {
          staticClass: "auth-saas__brand-mark",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v("S")]
      ),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticClass: "auth-saas__brand-wordmark" }, [
          _vm._v("Sipinor"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "auth-saas__brand-product" }, [
          _vm._v("Admin Console"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Centralized operations")]),
      _vm._v(" "),
      _c("span", [_vm._v("Tenants, billing, and configuration in one place")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Role-based security")]),
      _vm._v(" "),
      _c("span", [_vm._v("Least-privilege access for every administrator")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Operational clarity")]),
      _vm._v(" "),
      _c("span", [_vm._v("Status, alerts, and activity you can act on")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__mobile-brand d-lg-none" }, [
      _c(
        "span",
        {
          staticClass: "auth-saas__brand-mark auth-saas__brand-mark--sm",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v("S")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("Sipinor Admin")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__footer" }, [
      _c("p", [_vm._v("© Sipinor Educational Solutions")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }